// src/modules/Scheduling/shared/availability/block-keys.ts
var lastKey = 0;
function makeBlockKey() {
	lastKey += 1;
	return `block-${lastKey}`;
}
function toEditableAvailability(availability) {
	const { unavailableTimes, ...rest } = availability ?? {};
	return unavailableTimes ? {
		...rest,
		unavailableTimes: unavailableTimes.map((block) => ({
			...block,
			key: makeBlockKey()
		}))
	} : rest;
}
/**
* What a write sends. Blocks are rebuilt field by field, so neither an editor
* key nor an `id` stored before the contract dropped it goes out.
*/
function toSavedAvailability(availability) {
	const { unavailableTimes, ...rest } = availability;
	return unavailableTimes ? {
		...rest,
		unavailableTimes: unavailableTimes.map(toSavedBlock)
	} : rest;
}
function toSavedBlock({ allDay, day, end, start }) {
	return {
		allDay,
		day,
		...end !== void 0 && { end },
		...start !== void 0 && { start }
	};
}
export { makeBlockKey, toEditableAvailability, toSavedAvailability };

//# sourceMappingURL=block-keys.js.map